import React from 'react';
import { useLocation, Link } from 'react-router';

export function MagicLinkSentPage() {
  const location = useLocation();
  const email = (location.state as any)?.email || 'your email';

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm space-y-6 text-center">
        <h1 className="text-2xl font-bold font-heading text-foreground">Check your email</h1>
        <p className="text-sm text-muted-foreground">
          We sent a sign-in link to <span className="font-medium text-foreground">{email}</span>.
          Click the link in the email to sign in.
        </p>
        <p className="text-xs text-muted-foreground">
          The link expires in 15 minutes. Check your spam folder if you don't see it.
        </p>
        <Link to="/auth/login" className="inline-block text-sm text-primary hover:underline">
          Back to sign in
        </Link>
      </div>
    </div>
  );
}
